import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactModal from 'react-modal';
import clsx from 'clsx';
import Spinner from '../LazyWidgets/Spinner';
import MLIcon from '../MLIcon';
import MLButton from '../MLButton';
import s from './MLDialog.module.css';

ReactModal.setAppElement(document.body);

class MLDialog extends Component {
  static defaultProps = {
    onActionsSubmit: null,
    titleClassName: '',
    className: '',
    bodyClassName: '',
    actionsClassName: '',
    closeButtonClassName: '',
    isRequired: false,
  }

  static propTypes = {
    app: PropTypes.object,
    onClose: PropTypes.func,
    show: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]).isRequired,
    children: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    actions: PropTypes.array,
    footerErrors: PropTypes.array,
    onActionsSubmit: PropTypes.func,
    titleClassName: PropTypes.string,
    titleTextClassName: PropTypes.string,
    closeButtonClassName: PropTypes.string,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    overlayClassName: PropTypes.string,
    actionsClassName: PropTypes.string,
    isRequired: PropTypes.bool,
    testId: PropTypes.string,
    closeTestId: PropTypes.string,
    hideActionsBorder: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { onActionsSubmit } = this.props;
    let keydownListener = null;
    if (onActionsSubmit) {
      keydownListener = this.handleKeyDown.bind(this);
      document.addEventListener('keydown', keydownListener);
    }
    this.state = {
      keydownListener,
    };
  }

  componentDidMount() {
    ReactModal.setAppElement('body');

    // make background not scrollable
    const container = document.getElementById('container');
    if (container) container.classList.add(s.__dialogOpen);
    // make background not focusable
    if (container) ReactModal.setAppElement(container);
  }

  componentWillUnmount() {
    const { keydownListener } = this.state;
    if (keydownListener) {
      document.removeEventListener('keydown', keydownListener);
    }
    // make background scrollable
    const container = document.getElementById('container');
    if (container) container.classList.remove(s.__dialogOpen);
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      this.props.onActionsSubmit();
    }
  }

  renderTitle() {
    const { title, titleTextClassName } = this.props;
    if (typeof title === 'string') {
      return (<h2 className={`${s.dialogTitleText} ${titleTextClassName || ''}`} id="__mlDialog_title">{title}</h2>);
    }
    return (<h2 className={s.dialogTitleContainer} id="__mlDialog_title">{title}</h2>);
  }

  renderActions() {
    const { actions } = this.props;
    return _.map(actions, (action, i) => {
      const actionClassName = action.props.actionClassName || '';
      return (
        <div key={i} className={actionClassName}>
          {action}
        </div>
      );
    });
  }

  renderFooterErrorMessages = footerErrors => [
    <MLIcon
      type="warning"
      className={s.warningIcon}
    />,
    <div className={s.errorMessageContainer}>
      {footerErrors.map(({ message, hasAsterisk = true, errorType }, i) => (
        <div className={s.errorMessage} key={i} data-test-id={errorType || `error_message_${i}`}>
          {hasAsterisk ? '*' : ''}{message}
        </div>
      ))}
    </div>,
  ];

  render() {
    const {
      show,
      onClose,
      children,
      actions,
      title,
      titleClassName,
      className,
      bodyClassName,
      actionsClassName,
      closeButtonClassName,
      isRequired,
      footerErrors,
      testId,
      closeTestId,
      overlayClassName,
      app,
      hideActionsBorder,
    } = this.props;
    const isLoading = _.get(app, 'loading', false);
    let actionClasses = `${s.dialogActions} ${s.dialogActionsBorder} ${actionsClassName}`;
    if (hideActionsBorder) {
      actionClasses = `${s.dialogActions} ${actionsClassName}`;
    }
    return (
      <ReactModal
        contentLabel=""
        className={`${s.dialog} ${className}`}
        overlayClassName={clsx(s.dialogOverlay, overlayClassName)}
        isOpen={show}
        onRequestClose={onClose}
        role="dialog"
        aria={{
          labelledby: '__mlDialog_title',
          modal: 'true',
        }}
        shouldCloseOnOverlayClick={!isRequired}
        parentSelector={() => document.body}
        data={{ 'test-id': testId }}
      >
        <div className={title === '' ? s.dialogNoTitle : `${s.dialogTitle} ${titleClassName}`}>
          {this.renderTitle()}
          {!isRequired &&
            <MLButton
              className={`${s.closeBtn} ${closeButtonClassName}`}
              onClick={onClose}
              ariaLabel="close"
              testId={closeTestId}
            >
              <MLIcon
                className={s.closeIcon}
                type="x"
                title="Close"
              />
            </MLButton>
          }
        </div>
        { isLoading && <Spinner className={s.loading} />}
        <div className={`${s.dialogBody} ${bodyClassName} ${isLoading && s.opacity}`}>
          {children}
        </div>
        {
          actions &&
          <div className={actionClasses}>
            <div className={s.errorContainer}>
              {footerErrors && footerErrors.length > 0 && this.renderFooterErrorMessages(footerErrors)}
            </div>
            <div className={s.actionContainer}>
              {this.renderActions()}
            </div>
          </div>
        }
      </ReactModal>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

export default connect(mapStateToProps)(MLDialog);
